import { render, staticRenderFns } from "./NutricaoAlimentacaoVisitaCard.vue?vue&type=template&id=4d13885a&"
import script from "./NutricaoAlimentacaoVisitaCard.vue?vue&type=script&lang=js&"
export * from "./NutricaoAlimentacaoVisitaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports